export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export enum CommnetType {
  Attachments = 'Attachments',
  Picture = 'Picture',
  Text = 'Text',
}

export type Mutation = {
  __typename?: 'Mutation';
  insertMessageForSupport: Maybe<StandaloneSupportMessage>;
  markSupportThreadAsRead: Maybe<MutationStatus>;
  startSupportThread: Maybe<MutationStatus>;
};

export type MutationInsertMessageForSupportArgs = {
  message: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  type: CommnetType;
};

export type MutationMarkSupportThreadAsReadArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationStartSupportThreadArgs = {
  initMessage: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationStatus = {
  __typename?: 'MutationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type Query = {
  __typename?: 'Query';
  getAttachmentDownloadTask: Maybe<Scalars['String']['output']>;
  getSupportChatMessages: Maybe<Array<Maybe<StandaloneSupportMessage>>>;
  getSupportMember: Maybe<SupportMember>;
  getZalamoSupportThread: Maybe<ZalamoSupportThread>;
};

export type QueryGetAttachmentDownloadTaskArgs = {
  messageId: Scalars['ID']['input'];
};

export type QueryGetSupportChatMessagesArgs = {
  conversationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type QueryGetSupportMemberArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetZalamoSupportThreadArgs = {
  organizationId: Scalars['ID']['input'];
};

export type StandaloneSupportMessage = {
  __typename?: 'StandaloneSupportMessage';
  authorId: Maybe<Scalars['ID']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['Int']['output']>;
  standaloneSupportMessageId: Maybe<Scalars['ID']['output']>;
  type: Maybe<CommnetType>;
};

export type Subscription = {
  __typename?: 'Subscription';
  messageFromSupportSent: Maybe<StandaloneSupportMessage>;
  supportInited: Maybe<ZalamoSupportThread>;
  supportThreadUpdatedBySupport: Maybe<ZalamoSupportThread>;
};

export type SubscriptionMessageFromSupportSentArgs = {
  supportThreadId: Scalars['ID']['input'];
};

export type SubscriptionSupportInitedArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubscriptionSupportThreadUpdatedBySupportArgs = {
  supportThreadId: Scalars['ID']['input'];
};

export type SupportMember = {
  __typename?: 'SupportMember';
  avatar: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  supportMemberId: Maybe<Scalars['ID']['output']>;
  userId: Maybe<Scalars['ID']['output']>;
};

export enum SupportStatus {
  Away = 'Away',
  Offline = 'Offline',
  Online = 'Online',
}

export type ZalamoSupportThread = {
  __typename?: 'ZalamoSupportThread';
  conversationId: Maybe<Scalars['ID']['output']>;
  currentSupportMember: Maybe<SupportMember>;
  onlineStatus: Maybe<SupportStatus>;
  supportTeamId: Maybe<Scalars['ID']['output']>;
  supportThreadId: Maybe<Scalars['ID']['output']>;
  unreadCount: Maybe<Scalars['Int']['output']>;
};
